var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavIconComputer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.06,
    height: 17.415,
    viewBox: "0 0 17.06 17.415",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_222",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 222",
    transform: "translate(-344 -3659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_51",
    "data-name": "\\u30D1\\u30B9 51",
    d: "M-39.159,454.1H-54.018a1.116,1.116,0,0,0-1.1,1.123v11.21a1.115,1.115,0,0,0,1.1,1.123h5.879v2.375h-1.939a1.568,1.568,0,0,0-1.551,1.583h10.081a1.567,1.567,0,0,0-1.551-1.583h-1.939v-2.375h5.879a1.115,1.115,0,0,0,1.1-1.123V455.22A1.115,1.115,0,0,0-39.159,454.1Zm-.063,11.478H-53.955V455.284h14.733Z",
    transform: "translate(399.118 3204.903)",
    fill: "#4477c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-book",
    "data-name": "Icon ionic-md-book",
    d: "M10.562,5.634l-3.235.594L4.093,5.634a.663.663,0,0,0-.718.7V10.87c0,.384.3.605.718.7l3.235.592,3.235-.594c.414-.093.718-.314.718-.7V6.332A.663.663,0,0,0,10.562,5.634Zm0,5.234-2.873.594V6.924l2.873-.594Zm-3.6.594-2.873-.594V6.332l2.873.594Z",
    transform: "translate(345.202 3656.702)",
    fill: "#4477c0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconComputer);
export default __webpack_public_path__ + "static/media/nav-icon-computer.320bd6fcb8c3a10a1cf52060f636e392.svg";
export { ForwardRef as ReactComponent };